// removed by extract-text-webpack-plugin
module.exports = {"InputText":"InputText__InputText___1YeM6"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/InputText/InputText.less
// module id = 1434
// module chunks = 0 1